import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { useLanguage } from "@/i18n/LanguageContext";
import { adminStats, fetchSessions, type ConferenceSession } from "../api";
import { formatDateTime, pickLocalized } from "../format";
import { PageHeader } from "../shells/PageHeader";

export function AdminHomePage() {
  const { t, locale } = useLanguage();
  const [stats, setStats] = useState<{
    total_registrations: number;
    papers_submitted: number;
    accepted_papers: number;
    upcoming_sessions: number;
    checked_in: number;
  } | null>(null);
  const [live, setLive] = useState<ConferenceSession | null>(null);

  useEffect(() => {
    adminStats().then(setStats).catch(() => setStats(null));
    fetchSessions().then((s) => setLive(s.find((x) => x.status === "live") || null));
  }, []);

  const cards = stats
    ? [
        [t.admin.statsRegs, stats.total_registrations],
        [t.admin.statsPapers, stats.papers_submitted],
        [t.admin.statsAccepted, stats.accepted_papers],
        [t.admin.statsUpcoming, stats.upcoming_sessions],
        [t.admin.statsCheckedIn, stats.checked_in],
      ]
    : [];

  return (
    <div>
      <PageHeader title={t.admin.title} />
      <div className="dn-grid" style={{ marginBottom: "1.5rem" }}>
        {cards.map(([label, value]) => (
          <div className="dn-card" key={String(label)}>
            <h3>{label}</h3>
            <p style={{ fontSize: "1.8rem", fontFamily: "var(--dn-font-display)" }}>{value}</p>
          </div>
        ))}
      </div>
      <div className="dn-cta-row" style={{ marginBottom: "1.5rem" }}>
        <Link className="dn-btn dn-btn-primary" to="/admin/registrations">
          {t.admin.registrations}
        </Link>
        <Link className="dn-btn dn-btn-ghost" to="/admin/reviewers">
          {t.admin.reviewers}
        </Link>
        <Link className="dn-btn dn-btn-ghost" to="/admin/papers">
          {t.admin.papers}
        </Link>
        <Link className="dn-btn dn-btn-ghost" to="/admin/past-events">
          {t.admin.pastEvents}
        </Link>
        <Link className="dn-btn dn-btn-ghost" to="/admin/sessions">
          {t.admin.sessions}
        </Link>
        <Link className="dn-btn dn-btn-ghost" to="/admin/reminders">
          {t.admin.reminders}
        </Link>
        <Link className="dn-btn dn-btn-gold" to="/admin/settings">
          {t.admin.settings}
        </Link>
      </div>
      {live && (
        <div className="dn-card">
          <span className="dn-badge-live">{t.schedule.liveNow}</span>
          <p>{pickLocalized(live, locale, "title_en", "title_ar")}</p>
          <p className="dn-muted">{formatDateTime(live.starts_at, locale)}</p>
        </div>
      )}
    </div>
  );
}
